/**
 * Componente SidebarLink enlace individual con icono.
 */

import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { StyleClass } from 'primereact/styleclass';
import { Ripple } from 'primereact/ripple';

const SidebarLink = ({ label, icon, badge, children, path, onSelect  }) => {

  const ref = useRef(null);
  const navigate = useNavigate();

  const handleClick = () => {
    if (path) {
      navigate(path);
      if (onSelect) onSelect();
    }
  };

  const content = (
    <button 
      ref={ref}
      type="button"
      onClick={handleClick}
      className={'p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full bg-transparent border-none text-left'}
    >
      <i className={`${icon} mr-2`}></i>
      <span className="font-medium">{label}</span>
      {badge && (
        <span className="ml-auto bg-blue-500 text-0 border-circle flex align-items-center justify-content-center" style={{ minWidth: '1.5rem', height: '1.5rem' }}>
          {badge}
        </span>
      )}
      {children && <i className="pi pi-chevron-down ml-auto mr-1"></i>}
      <Ripple />
    </button>
  );

  if (children) {
    return (
      <li>
        <StyleClass nodeRef={ref} selector="@next" enterFromClassName="hidden" enterActiveClassName="slidedown" leaveToClassName="hidden" leaveActiveClassName="slideup">
          {content}
        </StyleClass>
        <ul className="list-none pl-3 pr-0 m-0 hidden overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out">
          {children.map((child, idx) => (
            <SidebarLink key={idx} {...child} />
          ))}
        </ul>
      </li>
    );
  }

  return <li>{content}</li>;
};

export default SidebarLink;
